export function watchProperty(element, prop, cb) {
    var el = element;
    if (!el.hasOwnProperty('__watchedProperties')) {
        var nativeSetAttr_1 = Object.getOwnPropertyDescriptor(Element.prototype, 'setAttribute');
        var nativeRemoveAttr_1 = Object.getOwnPropertyDescriptor(Element.prototype, 'removeAttribute');
        Object.defineProperty(el, '__watchedProperties', {
            writable: true,
            configurable: true,
            enumerable: false,
            value: {}
        });
        Object.defineProperties(el, {
            setAttribute: {
                writable: true,
                configurable: true,
                enumerable: true,
                value: function (attr, value) {
                    nativeSetAttr_1.value.apply(this, arguments);
                    if (this.__watchedProperties[attr]) {
                        notify(this, attr);
                    }
                }
            },
            removeAttribute: {
                writable: true,
                configurable: true,
                enumerable: true,
                value: function (attr) {
                    nativeRemoveAttr_1.value.apply(this, arguments);
                    if (this.__watchedProperties[attr]) {
                        notify(this, attr);
                    }
                }
            }
        });
    }
    if (!el.__watchedProperties[prop]) {
        var nativeDesc_1 = Object.getOwnPropertyDescriptor(findPropertyOwner(el, prop), prop);
        Object.defineProperty(el, prop, {
            get: function () {
                return nativeDesc_1.get.call(this);
            },
            set: function (v) {
                nativeDesc_1.set.call(this, v);
                notify(this, prop);
            },
            enumerable: nativeDesc_1.enumerable,
            configurable: true
        });
        el.__watchedProperties[prop] = [];
    }
    el.__watchedProperties[prop].push(cb);
    return function unwatch() {
        var index = el.__watchedProperties[prop].indexOf(cb);
        el.__watchedProperties[prop].splice(index, 1);
    };
}
function notify(element, prop) {
    element.__watchedProperties[prop].forEach(function (cb) { return cb(); });
}
export function findPropertyOwner(object, property) {
    if (object === null) {
        return null;
    }
    else if (object.hasOwnProperty(property)) {
        return object;
    }
    else {
        return findPropertyOwner(Object.getPrototypeOf(object), property);
    }
}
